// ProductList.js
import React, {useEffect} from 'react';
import ProductItem from './ProductItem';
import { ProductWrapper } from './styles'; // Adjust according to your actual styled-components
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ProductList = ({ data, setSelectedProduct, setShowModal }) => {
  // Log the data once when the component receives new props
  useEffect(() => {
    console.log('Product data received in ProductList:', data);
  }, [data]);

  if (!Array.isArray(data) || data.length === 0) {
    return (
      <ProductWrapper>
        {Array(8)
          .fill()
          .map((_, index) => (
            <div key={index} className="skeleton-wrapper">
              <Skeleton
                height={0}
                style={{ paddingTop: "133%", borderRadius: 12, display: "block" }}
              />
              <div style={{ padding: "0.6rem 0.15rem 0" }}>
                <Skeleton width="70%" />
                <Skeleton width="40%" />
              </div>
            </div>
          ))}
      </ProductWrapper>
    );
  }

  return (
    <ProductWrapper>
      {data.map((product) => (
        <ProductItem
          key={product.id}
          product={product}
          setSelectedProduct={setSelectedProduct}
          setShowModal={setShowModal}
        />
      ))}
    </ProductWrapper>
  );
};

export default ProductList;
